// import AboutSection from "../components/AboutSection";
import ServicesGrid from "../components/ServicesGrid";
import BlogList from "../components/BlogList";
import Testimonials from "../components/Testimonials";
import Footer from "../components/Footer";
import HeroSlider from "../components/HeroSlider";
import Yatak from "../components/ServiceRegions/İntros/Yatak";


const YatakWashing = () => {
  return (
    <> 
    <div>
        
      <HeroSlider />
      <Yatak/>
      {/* <AboutSection /> */}
      <ServicesGrid />
      <BlogList/>
      <Testimonials/>
      <Footer/>
      {/* <AboutSection /> */}
     
    </div>
     </>
  );
};

export default YatakWashing;